/**
 * Chuỗi của Trung tâm thông báo (ADR-0102): màn Cảnh báo ở cổng tenant (`/he-thong/canh-bao`) và cổng nền tảng
 * (`/canh-bao`) — tách tệp khi dựng song song, sẽ gộp vào `vi.ts`. Khoá cấp một mang tiền tố `canhBao`.
 *
 * Mã loại cảnh báo có dấu chấm (`subscription.expiring`) đổi thành gạch dưới khi làm khoá (`khoaLoai`).
 */
export const viCanhBao = {
  canhBao: {
    nhanNav: 'Cảnh báo',
    moNav: 'Kênh nhận tin, tác vụ cảnh báo và nhật ký gửi',
    nhanNavTenant: 'Cảnh báo và thông báo',
    tieuDe: 'Cảnh báo và thông báo',
    moTaTenant:
      'Cấu hình kênh nhận tin như Email, Telegram, đặt tác vụ cảnh báo cho tổ chức và xem lại những gì đã gửi.',
    moTaNenTang:
      'Kênh và tác vụ cảnh báo để đội vận hành nhận tin, danh mục kênh theo gói, và giám sát việc gửi của mọi tenant.',
    tabTacVu: 'Danh sách cảnh báo',
    tabKenh: 'Cấu hình kênh',
    tabNhatKy: 'Nhật ký cảnh báo',
    tabDanhMuc: 'Danh mục',
    tabGiamSat: 'Giám sát gửi',
    suDung: 'Đã gửi {{so}} / {{toiDa}} tin tháng này',
    suDungKhongGioiHan: 'Đã gửi {{so}} tin tháng này',
    suDungGanHet: 'Đã dùng {{phanTram}}% hạn mức tin của tháng.',

    themTacVu: 'Thêm tác vụ',
    themTacVuDauTien: 'Thêm tác vụ đầu tiên',
    bangTacVu: 'Danh sách tác vụ cảnh báo',
    cotTieuDe: 'Tác vụ',
    cotBat: 'Bật',
    cotKenh: 'Gửi qua',
    cotDieuKien: 'Điều kiện',
    cotKiemCuoi: 'Kiểm lần cuối',
    cotDaGui: 'Đã gửi',
    theoSuKien: 'Theo sự kiện',
    soLan: '{{so}} lần',
    themSo: '+{{so}}',
    kenhDaGo: 'Không còn kênh',
    moiLanXayRa: 'Mỗi lần xảy ra',
    rongTacVu: 'Chưa có tác vụ cảnh báo nào',
    rongTacVuMo:
      'Mỗi tác vụ chọn một loại sự kiện, ngưỡng và các kênh nhận tin. Nếu chưa có kênh, tạo ở tab Cấu hình kênh trước.',
    loiTacVu: 'Không tải được danh sách cảnh báo: {{loi}}',
    suaTacVu: 'Sửa tác vụ',
    xemLichSu: 'Xem lịch sử',
    xoaTacVu: 'Xoá tác vụ',
    batTatNhan: 'Bật hoặc tắt {{ten}}',
    daThemTacVu: 'Đã thêm tác vụ {{ten}}.',
    daLuuTacVu: 'Đã lưu tác vụ {{ten}}.',
    daBatTacVu: 'Đã bật {{ten}}.',
    daTatTacVu: 'Đã tắt {{ten}}.',
    daXoaTacVu: 'Đã xoá tác vụ {{ten}}.',

    hopThem: 'Thêm tác vụ cảnh báo',
    hopSua: 'Sửa tác vụ cảnh báo',
    truongLoai: 'Loại cảnh báo',
    chonLoai: 'Chọn loại cảnh báo',
    nhomTenant: 'Của tổ chức',
    truongTieuDe: 'Tên tác vụ',
    tieuDeGoiY: 'Tên hiện ở danh sách và nhật ký.',
    truongKenh: 'Gửi qua',
    kenhGoiY: 'Chọn một hoặc nhiều cấu hình kênh.',
    chuaCoKenhNao: 'Chưa có cấu hình kênh nào.',
    moCauHinhKenh: 'Mở Cấu hình kênh',
    chuaCauHinhLoai: '{{kenh}}: chưa cấu hình',
    kenhDangTat: '{{ten}} (đang tắt)',
    caiDatNangCao: 'Cài đặt nâng cao',
    toiDaNgay: 'Tối đa mỗi ngày',
    toiDaTong: 'Tổng tối đa',
    deTrongKhongGioiHan: 'Để trống là không giới hạn.',
    khoangCach: 'Cách nhau tối thiểu (giây)',
    khoangCachGoiY: '600 giây là 10 phút.',
    khungGioTu: 'Gửi từ',
    khungGioDen: 'đến',
    khungGioGoiY: 'Ngoài khung giờ thì không gửi. Tin mức Nghiêm trọng vẫn gửi ngoài khung giờ.',
    batSauLuu: 'Bật tác vụ ngay',
    loiGioiHan: 'Nhập số nguyên từ 1 trở lên, hoặc để trống.',
    loiKhoangCach: 'Nhập số giây từ 0 đến 604.800.',
    loiChonKenh: 'Chọn ít nhất một kênh.',
    loiChonLoai: 'Chọn loại cảnh báo.',
    loiTieuDe: 'Nhập tên tác vụ.',
    loiKhungGio: 'Giờ theo dạng HH:mm, ví dụ 08:00.',
    nutThemTacVu: 'Thêm tác vụ',
    nutLuuTacVu: 'Lưu tác vụ',
    xnXoaTieuDe: 'Xoá tác vụ {{ten}}?',
    xnXoaThan:
      'Tác vụ ngừng kiểm và không gửi thêm tin nào. Nhật ký đã gửi vẫn được giữ tới hết thời gian lưu. Không hoàn tác được.',
    dangXoa: 'Đang xoá...',
    dangLuu: 'Đang lưu...',
  },

  canhBaoKenh: {
    bang: 'Các loại kênh nhận tin',
    cotKenh: 'Kênh',
    cotCauHinh: 'Cấu hình',
    chuaCauHinh: 'Chưa cấu hình',
    soCauHinh: '{{so}} cấu hình',
    soDangTat: '{{so}} đang tắt',
    xemHuongDan: 'Xem hướng dẫn',
    huongDanTieuDe: 'Hướng dẫn kết nối {{kenh}}',
    moCauHinh: 'Mở cấu hình {{kenh}}',
    nganTieuDe: 'Cấu hình {{kenh}}',
    them: 'Thêm cấu hình',
    themDauTien: 'Thêm cấu hình đầu tiên',
    rongNgan: 'Chưa có cấu hình {{kenh}} nào',
    rongNganMo: 'Thêm một cấu hình để tác vụ cảnh báo gửi được qua {{kenh}}.',
    rongLoai: 'Chưa có loại kênh nào được bật',
    rongLoaiMo: 'Quản trị nền tảng chưa bật loại kênh nào cho gói hiện tại.',
    loiDanhSach: 'Không tải được cấu hình kênh: {{loi}}',
    dangBat: 'Đang bật',
    dangTat: 'Đang tắt',
    tuTat: 'Tự tắt sau nhiều lần lỗi',
    thuDuocLuc: 'Gửi thử được lúc {{luc}}',
    thuHongLuc: 'Gửi thử lỗi lúc {{luc}}: {{loi}}',
    chuaThu: 'Chưa gửi thử',
    guiThu: 'Gửi thử',
    sua: 'Sửa',
    bat: 'Bật',
    tat: 'Tắt',
    go: 'Gỡ cấu hình',
    guiThuDuoc: 'Đã gửi thử qua {{ten}}.',
    guiThuHong: 'Gửi thử qua {{ten}} không được: {{loi}}',
    daThem: 'Đã thêm cấu hình {{ten}}.',
    daLuu: 'Đã lưu cấu hình {{ten}}.',
    daBat: 'Đã bật {{ten}}.',
    daTat: 'Đã tắt {{ten}}.',
    daGo: 'Đã gỡ cấu hình {{ten}}.',
    hopThem: 'Thêm cấu hình {{kenh}}',
    hopSua: 'Sửa cấu hình {{kenh}}',
    truongTen: 'Tên cấu hình',
    tenGoiY: 'Ví dụ: Nhóm vận hành, Kế toán.',
    loiTen: 'Nhập tên cấu hình.',
    daLuuSecret: 'Đã lưu. Để trống để giữ nguyên.',
    nutThem: 'Thêm cấu hình',
    nutLuu: 'Lưu cấu hình',
    batCauHinh: 'Bật cấu hình này',
    layChatId: 'Lấy chat ID',
    canToken: 'Nhập bot token trước.',
    khongThayChat: 'Bot chưa nhận tin nhắn nào. Nhắn cho bot hoặc thêm bot vào nhóm rồi thử lại.',
    chonChat: 'Chọn chat nhận tin',
    loiChat: 'Không lấy được danh sách chat: {{loi}}',
    xnGoTieuDe: 'Gỡ cấu hình {{ten}}?',
    xnGoThan:
      'Secret của cấu hình bị xoá. Các tác vụ đang dùng cấu hình này sẽ không gửi qua đây nữa, lần gửi đang chờ bị huỷ. Không hoàn tác được.',
    dangGo: 'Đang gỡ...',
  },

  canhBaoNhatKy: {
    bang: 'Nhật ký cảnh báo',
    cotThoiGian: 'Thời gian',
    cotTacVu: 'Tác vụ',
    cotLoai: 'Loại',
    cotMuc: 'Mức',
    cotNoiDung: 'Nội dung',
    cotTrangThai: 'Trạng thái',
    cotTenant: 'Phạm vi',
    locTrangThai: 'Lọc theo trạng thái',
    moiTrangThai: 'Mọi trạng thái',
    locTacVu: 'Lọc theo tác vụ',
    moiTacVu: 'Mọi tác vụ',
    rong: 'Chưa gửi cảnh báo nào',
    rongMo: 'Mỗi lần một tác vụ kích hoạt, kể cả lần bị giới hạn gửi chặn lại, sẽ có một dòng ở đây.',
    rongLoc: 'Không có lần cảnh báo nào khớp bộ lọc',
    loi: 'Không tải được nhật ký: {{loi}}',
    taiThem: 'Tải thêm',
    soKenh: '{{dat}}/{{tong}} kênh',
    tacVuDaXoa: 'Tác vụ đã xoá',
    nenTang: 'Nền tảng',
    xemChiTiet: 'Xem chi tiết {{ten}}',
    chiTiet: 'Chi tiết lần cảnh báo',
    noiDung: 'Nội dung',
    cacLanGui: 'Gửi qua từng kênh',
    khongGui: 'Không gửi qua kênh nào.',
    lyDo: 'Lý do không gửi',
    xayRaLuc: 'Xảy ra lúc',
    thuLan: 'Lần thử {{so}}',
    doTre: '{{so}} ms',
    http: 'HTTP {{ma}}',
    thuLaiLuc: 'Thử lại lúc {{luc}}',
    guiLai: 'Gửi lại',
    dangGuiLai: 'Đang gửi lại...',
    daXepGuiLai: 'Đã xếp lần gửi lại vào hàng đợi.',
    laGuiLai: 'Gửi lại của một lần trước',
    loiChiTiet: 'Không tải được chi tiết: {{loi}}',
    soLanThu: '{{so}} lần thử',
  },

  canhBaoNenTang: {
    kpiCanhBao: 'Cảnh báo trong 24 giờ',
    kpiDaGui: 'Đã gửi',
    kpiLoi: 'Lỗi',
    kpiChan: 'Bị giới hạn chặn',
    kpiCho: 'Đang chờ gửi',
    kpiHetLuot: 'Hết lượt thử',
    theoKenh: 'Theo kênh trong 24 giờ',
    theoKenhDong: '{{dat}} thành công, {{loi}} lỗi',
    loiTongQuan: 'Không tải được tổng quan: {{loi}}',
    locPhamVi: 'Lọc phạm vi',
    moiPhamVi: 'Mọi tenant và nền tảng',
    chiNenTang: 'Chỉ nền tảng',
    motTenant: 'Một tenant',
    maTenant: 'Mã tenant (UUID)',
    maTenantSai: 'Mã tenant là UUID, ví dụ 0a7d3c5e-1f2b-4e6a-9c8d-000000000005.',
    bangLoaiKenh: 'Loại kênh',
    bangLoaiCanhBao: 'Loại cảnh báo',
    cotBat: 'Bật',
    cotGoi: 'Gói được dùng',
    cotNguon: 'Nguồn dữ liệu',
    cotPhamVi: 'Phạm vi',
    cotKichHoat: 'Kích hoạt',
    cotPhienBan: 'Phiên bản adapter',
    chuaCoNguon: 'Chưa có nguồn',
    coNguon: 'Sẵn sàng',
    phamViTenant: 'Tenant',
    phamViNenTang: 'Nền tảng',
    dinhKy: 'Kiểm mỗi {{phut}} phút',
    daLuuDanhMuc: 'Đã lưu danh mục.',
    loiDanhMuc: 'Không tải được danh mục: {{loi}}',
    batNhan: 'Bật hoặc tắt {{ten}}',
    goiNhan: 'Gói được dùng {{ten}}',
    rongDanhMuc: 'Danh mục trống',
  },

  canhBaoMa: {
    kenh: {
      TELEGRAM: 'Telegram',
      EMAIL: 'Email',
      WEBHOOK: 'Webhook',
      DISCORD: 'Discord',
      DINGTALK: 'DingTalk',
      WECOM: 'WeCom',
      FEISHU: 'Feishu',
    },
    moKenh: {
      TELEGRAM: 'Gửi qua bot Telegram vào một chat hoặc nhóm.',
      EMAIL: 'Gửi email bằng SMTP riêng hoặc máy chủ thư của nền tảng.',
      WEBHOOK: 'Gọi HTTPS tới hệ thống của tổ chức, có ký HMAC.',
      DISCORD: 'Gửi vào một kênh Discord qua webhook.',
      DINGTALK: 'Gửi qua robot nhóm DingTalk.',
      WECOM: 'Gửi qua robot nhóm WeCom.',
      FEISHU: 'Gửi qua robot nhóm Feishu hoặc Lark.',
    },
    huongDan: {
      TELEGRAM:
        '1. Mở Telegram, nhắn @BotFather lệnh /newbot rồi làm theo để tạo bot; BotFather trả về bot token.\n2. Nhắn cho bot một tin bất kỳ, hoặc thêm bot vào nhóm sẽ nhận cảnh báo.\n3. Thêm cấu hình, dán bot token, bấm Lấy chat ID rồi chọn chat.\n4. Lưu, rồi bấm Gửi thử để kiểm tra.',
      EMAIL:
        '1. Không có máy chủ thư riêng thì bật "Dùng máy chủ thư của nền tảng", chỉ cần nhập email nhận.\n2. Dùng SMTP riêng: cổng 465 là SSL/TLS (khuyên dùng), 587 là STARTTLS. Không nhận kết nối không mã hoá.\n3. Email nhận mỗi dòng một địa chỉ. Nên dùng hộp thư nhóm để người nghỉ việc không làm rơi cảnh báo.\n4. Lưu, rồi bấm Gửi thử.',
      WEBHOOK:
        '1. Chuẩn bị một địa chỉ HTTPS công khai nhận POST hoặc PUT. Không nhận địa chỉ mạng nội bộ.\n2. Thân mặc định là JSON gồm title, message, type, severity, occurred_at. Muốn tự định dạng thì nhập Thân tuỳ biến, dùng các biến liệt kê dưới ô đó.\n3. Nhập Khoá ký để kiểm header X-Platform-Signature (HMAC-SHA256) ở phía nhận.\n4. Lưu, rồi bấm Gửi thử.',
      DISCORD:
        '1. Trong Discord, mở Cài đặt kênh → Tích hợp → Webhook → Tạo webhook.\n2. Chép Webhook URL và dán vào cấu hình.\n3. Lưu, rồi bấm Gửi thử.',
      DINGTALK:
        '1. Trong nhóm DingTalk, thêm robot tuỳ chỉnh và chọn bảo mật bằng khoá ký.\n2. Chép URL robot và khoá ký vào cấu hình.\n3. Lưu, rồi bấm Gửi thử.',
      WECOM:
        '1. Trong nhóm WeCom, thêm robot nhóm.\n2. Chép URL webhook của robot vào cấu hình.\n3. Lưu, rồi bấm Gửi thử.',
      FEISHU:
        '1. Trong nhóm Feishu hoặc Lark, thêm robot tuỳ chỉnh, bật xác minh chữ ký nếu muốn.\n2. Chép URL webhook và khoá ký vào cấu hình.\n3. Lưu, rồi bấm Gửi thử.',
    },
    muc: { INFO: 'Thông tin', WARNING: 'Cảnh báo', CRITICAL: 'Nghiêm trọng' },
    banGhi: {
      PENDING: 'Đang gửi',
      SENT: 'Đã gửi',
      PARTIAL: 'Gửi một phần',
      FAILED: 'Lỗi',
      SUPPRESSED: 'Bị chặn',
    },
    gui: {
      PENDING: 'Chờ gửi',
      PROCESSING: 'Đang gửi',
      SUCCEEDED: 'Thành công',
      RETRY_SCHEDULED: 'Chờ thử lại',
      FAILED_PERMANENT: 'Lỗi',
      DEAD_LETTERED: 'Hết lượt thử',
      CANCELLED: 'Đã huỷ',
    },
    lyDo: {
      DAILY_LIMIT: 'Đã đủ số lần trong ngày',
      TOTAL_LIMIT: 'Đã đủ tổng số lần',
      MIN_INTERVAL: 'Chưa đủ khoảng cách tối thiểu',
      SEND_WINDOW: 'Ngoài khung giờ gửi',
      QUOTA: 'Hết hạn mức tin của tháng',
      NOT_ENTITLED: 'Gói không còn được dùng',
      TENANT_INACTIVE: 'Tổ chức đang tạm ngưng',
      NO_CHANNEL: 'Không còn kênh nào đang bật',
    },
    loiGui: {
      AUTH_FAILED: 'Sai thông tin xác thực',
      NOT_FOUND: 'Không tìm thấy đích',
      RATE_LIMITED: 'Bị giới hạn tốc độ',
      TIMEOUT: 'Hết thời gian chờ',
      NETWORK: 'Lỗi mạng',
      TARGET_FORBIDDEN: 'Đích bị chặn',
      BAD_REQUEST: 'Yêu cầu không hợp lệ',
      SERVER_ERROR: 'Máy đích lỗi',
      CONFIG_INVALID: 'Cấu hình sai',
      CHANNEL_DISABLED: 'Kênh đang tắt',
      UNKNOWN: 'Lỗi không rõ',
    },
    ketQua: {
      SUCCEEDED: 'Thành công',
      TRANSIENT_ERROR: 'Lỗi tạm thời',
      PERMANENT_ERROR: 'Lỗi vĩnh viễn',
    },
    goi: {
      TRIAL: 'Dùng thử',
      STANDARD: 'Tiêu chuẩn',
      PROFESSIONAL: 'Chuyên nghiệp',
      ENTERPRISE: 'Doanh nghiệp',
    },
    loiTruong: {
      batBuoc: 'Nhập giá trị cho ô này.',
      emailSai: 'Có địa chỉ email sai dạng. Mỗi dòng một địa chỉ.',
      soNgoaiKhoang: 'Số nằm ngoài khoảng cho phép.',
      jsonSai: 'JSON sai cú pháp.',
      urlSai: 'Địa chỉ phải bắt đầu bằng https://.',
      gioSai: 'Giờ theo dạng HH:mm.',
    },
  },

  canhBaoTruong: {
    TELEGRAM: { chat_id: 'Chat ID', bot_token: 'Bot token' },
    EMAIL: {
      use_platform_smtp: 'Dùng máy chủ thư của nền tảng',
      smtp_host: 'SMTP server',
      smtp_port: 'SMTP port',
      sender: 'Email gửi',
      smtp_username: 'Tên đăng nhập SMTP',
      smtp_password: 'Mật khẩu SMTP',
      recipients: 'Email nhận',
    },
    WEBHOOK: {
      url: 'URL',
      method: 'Phương thức',
      content_type: 'Định dạng',
      body_template: 'Thân tuỳ biến (JSON)',
      headers: 'Header (JSON)',
      signing_secret: 'Khoá ký HMAC',
    },
    DISCORD: { webhook_url: 'Webhook URL' },
    DINGTALK: { webhook_url: 'URL robot', signing_secret: 'Khoá ký' },
    WECOM: { webhook_url: 'URL robot' },
    FEISHU: { webhook_url: 'URL robot', signing_secret: 'Khoá ký' },
  },

  canhBaoGoiY: {
    TELEGRAM: {
      chat_id: 'ID người dùng, hoặc ID nhóm (có dấu - ở đầu).',
      bot_token: 'Dạng 123456789:AAH… do @BotFather cấp.',
    },
    EMAIL: {
      use_platform_smtp: 'Bật thì chỉ cần nhập email nhận; số tin tính vào hạn mức của tháng.',
      smtp_host: 'Ví dụ smtp.congty.vn.',
      smtp_port: '465 là SSL/TLS (khuyên dùng), 587 là STARTTLS.',
      sender: 'Địa chỉ hiện ở ô Người gửi.',
      smtp_username: 'Để trống nếu trùng email gửi.',
      smtp_password: 'Lưu ở kho bí mật, không hiện lại.',
      recipients: 'Mỗi dòng một địa chỉ.',
    },
    WEBHOOK: {
      url: 'Chỉ nhận https:// tới địa chỉ Internet công khai.',
      method: 'POST hoặc PUT.',
      content_type: 'Kiểu nội dung của thân gửi đi.',
      body_template: 'Để trống thì dùng thân mặc định. Các biến dùng được:',
      headers: 'JSON dạng {"Authorization": "Bearer …"}. Lưu ở kho bí mật.',
      signing_secret: 'Có thì mỗi lần gửi kèm header X-Platform-Signature.',
    },
    DISCORD: { webhook_url: 'Dạng https://discord.com/api/webhooks/….' },
    DINGTALK: {
      webhook_url: 'Dạng https://oapi.dingtalk.com/robot/send?access_token=….',
      signing_secret: 'Khoá bắt đầu bằng SEC.',
    },
    WECOM: {
      webhook_url: 'Dạng https://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=….',
    },
    FEISHU: {
      webhook_url: 'Dạng https://open.feishu.cn/open-apis/bot/v2/hook/….',
      signing_secret: 'Khoá xác minh chữ ký của robot.',
    },
  },

  canhBaoLoai: {
    ten: {
      subscription_expiring: 'Gói dịch vụ sắp hết hạn',
      license_expiring: 'License sắp hết hạn',
      quota_ai_tokens: 'Hạn mức token AI',
      quota_users: 'Hạn mức người dùng',
      quota_storage: 'Hạn mức dung lượng',
      quota_notifications: 'Hạn mức tin thông báo',
      security_login_failed: 'Đăng nhập sai nhiều lần',
      security_user_locked: 'Tài khoản bị khoá',
      security_admin_login: 'Quản trị viên đăng nhập',
      security_alert: 'Cảnh báo bảo mật',
      security_ip_blocked: 'IP bị chặn',
      domain_verification_lost: 'Mất xác minh domain',
      module_unavailable: 'Module ngừng phản hồi',
      module_event: 'Sự kiện của module',
      notify_channel_failed: 'Kênh nhận tin bị lỗi',
      infra_metric: 'Tài nguyên máy chủ',
      infra_alertmanager: 'Cảnh báo hạ tầng (Alertmanager)',
      platform_service_down: 'Service ngừng phản hồi',
      platform_kafka_lag: 'Kafka xử lý chậm',
      platform_dead_letter: 'Tin hết lượt thử tăng',
      platform_security_critical: 'Bảo mật nghiêm trọng',
      platform_ops_warning: 'Cảnh báo vận hành',
      platform_license_expiring: 'License của tenant sắp hết hạn',
      platform_ai_token_request: 'Yêu cầu cấp thêm token AI',
      platform_tenant_over_quota: 'Tenant vượt hạn mức',
    },
    mo: {
      subscription_expiring: 'Báo trước khi kỳ thuê bao gói dịch vụ kết thúc.',
      license_expiring: 'Báo trước khi license của bản cài on-premise hết hạn.',
      quota_ai_tokens: 'Báo khi token AI trong tháng dùng tới mức đã chọn.',
      quota_users: 'Báo khi số người dùng gần chạm hạn mức của gói.',
      quota_storage: 'Báo khi dung lượng dữ liệu gần chạm hạn mức của gói.',
      quota_notifications: 'Báo khi số tin cảnh báo trong tháng gần hết hạn mức.',
      security_login_failed: 'Báo khi có nhiều lần đăng nhập sai trong một khoảng thời gian ngắn.',
      security_user_locked: 'Báo khi một tài khoản bị khoá tạm vì đăng nhập sai hoặc phiên bất thường.',
      security_admin_login: 'Báo mỗi khi quản trị viên đăng nhập.',
      security_alert: 'Báo khi quy tắc cảnh báo bảo mật của tổ chức kích hoạt.',
      security_ip_blocked: 'Báo khi một IP bị chặn truy cập.',
      domain_verification_lost: 'Báo khi lần kiểm lại DNS không còn thấy bản ghi xác minh.',
      module_unavailable: 'Báo khi một module tổ chức đang dùng ngừng phản hồi.',
      module_event: 'Báo khi module phát sự kiện đã chọn, ví dụ OCR xử lý xong.',
      notify_channel_failed: 'Báo qua các kênh còn lại khi một cấu hình kênh tự tắt vì lỗi liên tiếp.',
      infra_metric: 'Báo khi CPU, bộ nhớ, ổ đĩa hay tải vượt ngưỡng trong một khoảng thời gian.',
      infra_alertmanager: 'Chuyển tiếp cảnh báo của Alertmanager.',
      platform_service_down: 'Báo khi một service không sẵn sàng.',
      platform_kafka_lag: 'Báo khi consumer Kafka tụt sau quá ngưỡng.',
      platform_dead_letter: 'Báo khi số tin hết lượt thử tăng bất thường.',
      platform_security_critical: 'Dò mật khẩu, khoá phiên lặp lại, chuỗi băm audit bị phá.',
      platform_ops_warning: 'Cảnh báo vận hành của các service nền tảng.',
      platform_license_expiring: 'License của một tenant on-premise sắp hết hạn.',
      platform_ai_token_request: 'Tenant gửi yêu cầu cấp thêm token AI.',
      platform_tenant_over_quota: 'Báo khi một tenant dùng hết hạn mức tin của tháng.',
    },
    thamSo: {
      days_before: 'Báo trước (ngày)',
      threshold_percent: 'Ngưỡng (%)',
      count: 'Số lần',
      window_minutes: 'Trong khoảng (phút)',
      min_severity: 'Mức tối thiểu',
      level: 'Mức đã dùng',
      lag_threshold: 'Lag tối thiểu (bản tin)',
      metric: 'Chỉ số',
      duration_minutes: 'Kéo dài (phút)',
    },
    tuyChon: {
      CPU: 'CPU',
      MEMORY: 'Bộ nhớ',
      DISK: 'Ổ đĩa',
      LOAD: 'Tải hệ thống',
      '80': '80%',
      '100': '100%',
      INFO: 'Thông tin',
      WARNING: 'Cảnh báo',
      CRITICAL: 'Nghiêm trọng',
    },
  },
};
